import React from "react";
import { Box, Typography } from "@mui/material";
import {
  getViewerPanelPaddingSx,
  viewerActionButtonLabelSx,
  viewerPanelBodySx,
  viewerPanelEyebrowSx,
  viewerPanelHeaderSx,
  viewerPanelHeadingGroupSx,
  viewerPanelSurfaceSx,
  viewerPanelTitleSx,
  viewerPillActionButtonSx,
} from "./panelStyles";

export const IOS_RELEASE = Object.freeze({
  destination: "https://apps.apple.com/us/app/10k-science/id6793177913",
  eyebrow: "10k Science for iOS",
  title: "Now on the App Store",
  description:
    "Download 10k Science and start exploring on your iPhone or iPad.",
  actionLabel: "Download on the App Store",
});

const getPublicAssetUrl = (path) =>
  `${process.env.PUBLIC_URL || ""}${path}`;

const MobileFallback = ({ isPhone }) => {
  const heroSrc = getPublicAssetUrl(
    isPhone
      ? "/ios/10k-ios-hero-iphone.webp"
      : "/ios/10k-ios-hero-ipad.webp",
  );

  return (
    <Box
      component="main"
      sx={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        minHeight: "100dvh",
        backgroundColor: "#05090f",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={heroSrc}
        alt={
          isPhone
            ? "10k Science interactive experiences on iPhone"
            : "10k Science interactive experiences on iPad"
        }
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
        }}
      />

      <Box
        aria-hidden="true"
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, transparent 52%, rgba(2, 8, 13, 0.18) 68%, rgba(2, 8, 13, 0.72) 100%)",
          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          ...viewerPanelSurfaceSx,
          ...getViewerPanelPaddingSx(isPhone),
          position: "absolute",
          right: isPhone ? 12 : 24,
          bottom: isPhone
            ? "calc(env(safe-area-inset-bottom, 0px) + 12px)"
            : "calc(env(safe-area-inset-bottom, 0px) + 24px)",
          left: isPhone ? 12 : "auto",
          width: isPhone ? "auto" : "min(440px, calc(100% - 48px))",
          boxSizing: "border-box",
        }}
      >
        <Box sx={viewerPanelHeaderSx}>
          <Box sx={viewerPanelHeadingGroupSx}>
            <Typography component="p" sx={viewerPanelEyebrowSx}>
              {IOS_RELEASE.eyebrow}
            </Typography>
            <Typography component="h1" sx={viewerPanelTitleSx}>
              {IOS_RELEASE.title}
            </Typography>
          </Box>
        </Box>

        <Typography sx={{ ...viewerPanelBodySx, mt: 0.85 }}>
          {IOS_RELEASE.description}
        </Typography>

        <Box
          component="a"
          href={IOS_RELEASE.destination}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${IOS_RELEASE.actionLabel} (opens in a new tab)`}
          sx={{ ...viewerPillActionButtonSx, width: "100%", mt: 1.5 }}
        >
          <Box
            component="span"
            className="control-label"
            sx={viewerActionButtonLabelSx}
          >
            {IOS_RELEASE.actionLabel}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MobileFallback;
